import { ChatMergeMode } from 'components/Chat/chatConstants';

const getChatMessageCount = (chat) => {
    return typeof chat?.total_message_count === 'number' ? chat.total_message_count : (chat?.messages || []).length;
};

const getChatMessagesVersion = (chat) => {
    return typeof chat?.messages_version === 'number' ? chat.messages_version : (chat?.messages || []).length;
};

const appendPersistedMessage = (chat, message) => {
    if (!chat) return chat;
    if ((chat.messages || []).some(({ id }) => id === message.id)) return chat;

    return {
        ...chat,
        modified_on: message.modified_on,
        messages_version: getChatMessagesVersion(chat) + 1,
        total_message_count: getChatMessageCount(chat) + 1,
        messages: [...(chat.messages || []), message],
    };
};

const mergeFetchedChatPage = ({ currentChat, nextChat, mode = ChatMergeMode.REPLACE }) => {
    if (!nextChat) return currentChat;
    if (mode !== ChatMergeMode.PREPEND || !currentChat) return nextChat;

    const currentMessageIds = new Set((currentChat.messages || []).map(({ id }) => id));
    const prependedMessages = (nextChat.messages || []).filter(({ id }) => !currentMessageIds.has(id));

    return {
        ...nextChat,
        messages: [...prependedMessages, ...(currentChat.messages || [])],
    };
};

const hasOlderMessages = (chat) => {
    return Boolean(chat?.has_more_messages && chat?.next_before_message_id);
};

const buildChatReconciliationPayload = (chat) => {
    if (!chat?.id) return {};

    return {
        chat_reconciliations: [
            {
                chat_id: chat.id,
                messages_version: getChatMessagesVersion(chat),
            },
        ],
    };
};

export {
    appendPersistedMessage,
    buildChatReconciliationPayload,
    getChatMessagesVersion,
    hasOlderMessages,
    mergeFetchedChatPage,
};
